(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'd2v-path-js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('d2v-path-js'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'd2v-shape-js'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'd2v-shape-js'.");
    }
    if (typeof this['d2v-path-js'] === 'undefined') {
      throw new Error("Error loading module 'd2v-shape-js'. Its dependency 'd2v-path-js' was not found. Please, check whether 'd2v-path-js' is loaded prior to 'd2v-shape-js'.");
    }
    root['d2v-shape-js'] = factory(typeof this['d2v-shape-js'] === 'undefined' ? {} : this['d2v-shape-js'], kotlin, this['d2v-path-js']);
  }
}(this, function (_, Kotlin, $module$d2v_path_js) {
  'use strict';
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var ensureNotNull = Kotlin.ensureNotNull;
  var Kind_INTERFACE = Kotlin.Kind.INTERFACE;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var math = Kotlin.kotlin.math;
  var Unit = Kotlin.kotlin.Unit;
  var IntRange = Kotlin.kotlin.ranges.IntRange;
  var PathAdapter = $module$d2v_path_js.io.data2viz.path.PathAdapter;
  var isNaN_0 = Kotlin.kotlin.isNaN_yrwdxr$;
  var until = Kotlin.kotlin.ranges.until_dqglrj$;
  var getCallableRef = Kotlin.getCallableRef;
  var Enum = Kotlin.kotlin.Enum;
  var throwISE = Kotlin.throwISE;
  var reversed = Kotlin.kotlin.collections.reversed_7wnvza$;
  function CornerTangentValues(cx, cy, x01, y01, x11, y11) {
    this.cx = cx;
    this.cy = cy;
    this.x01 = x01;
    this.y01 = y01;
    this.x11 = x11;
    this.y11 = y11;
  }
  CornerTangentValues.$metadata$ = {kind: Kind_CLASS, simpleName: 'CornerTangentValues', interfaces: []};
  CornerTangentValues.prototype.component1 = function () {
    return this.cx;
  };
  CornerTangentValues.prototype.component2 = function () {
    return this.cy;
  };
  CornerTangentValues.prototype.component3 = function () {
    return this.x01;
  };
  CornerTangentValues.prototype.component4 = function () {
    return this.y01;
  };
  CornerTangentValues.prototype.component5 = function () {
    return this.x11;
  };
  CornerTangentValues.prototype.component6 = function () {
    return this.y11;
  };
  CornerTangentValues.prototype.copy_15yvbs$ = function (cx, cy, x01, y01, x11, y11) {
    return new CornerTangentValues(cx === void 0 ? this.cx : cx, cy === void 0 ? this.cy : cy, x01 === void 0 ? this.x01 : x01, y01 === void 0 ? this.y01 : y01, x11 === void 0 ? this.x11 : x11, y11 === void 0 ? this.y11 : y11);
  };
  CornerTangentValues.prototype.toString = function () {
    return 'CornerTangentValues(cx=' + Kotlin.toString(this.cx) + (', cy=' + Kotlin.toString(this.cy)) + (', x01=' + Kotlin.toString(this.x01)) + (', y01=' + Kotlin.toString(this.y01)) + (', x11=' + Kotlin.toString(this.x11)) + (', y11=' + Kotlin.toString(this.y11)) + ')';
  };
  CornerTangentValues.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.cx) | 0;
    result = result * 31 + Kotlin.hashCode(this.cy) | 0;
    result = result * 31 + Kotlin.hashCode(this.x01) | 0;
    result = result * 31 + Kotlin.hashCode(this.y01) | 0;
    result = result * 31 + Kotlin.hashCode(this.x11) | 0;
    result = result * 31 + Kotlin.hashCode(this.y11) | 0;
    return result;
  };
  CornerTangentValues.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.cx, other.cx) && Kotlin.equals(this.cy, other.cy) && Kotlin.equals(this.x01, other.x01) && Kotlin.equals(this.y01, other.y01) && Kotlin.equals(this.x11, other.x11) && Kotlin.equals(this.y11, other.y11)))));
  };
  function arc(init) {
    var $receiver = new ArcGenerator();
    init($receiver);
    return $receiver;
  }
  function ArcGenerator() {
    this.innerRadius = const_0(0.0);
    this.outerRadius = const_0(100.0);
    this.cornerRadius = const_0(0.0);
    this.padRadius = null;
    this.startAngle = const_0(0.0);
    this.endAngle = const_0(0.0);
    this.padAngle = const_0(0.0);
  }
  var Math_0 = Math;
  ArcGenerator.prototype.centroid_11rb$ = function (datum) {
    var r = this.innerRadius(datum) + this.outerRadius(datum) / 2.0;
    var a = this.startAngle(datum) + this.endAngle(datum) / 2.0 - halfPi;
    return [Math_0.cos(a) * r, Math_0.sin(a) * r];
  };
  ArcGenerator.prototype.arc_htbjw1$ = function (datum, context) {
    var tmp$;
    var r0 = this.innerRadius(datum);
    var r1 = this.outerRadius(datum);
    var a0 = this.startAngle(datum) - halfPi;
    var a1 = this.endAngle(datum) - halfPi;
    var x = a1 - a0;
    var da = Math_0.abs(x);
    var cw = a1 > a0;
    if (r1 < r0) {
      var r = r1;
      r1 = r0;
      r0 = r;
    }
    if (r1 <= epsilon)
      context.moveTo_lu1900$(0.0, 0.0);
    else if (da > tau - epsilon) {
      context.moveTo_lu1900$(r1 * Math_0.cos(a0), r1 * Math_0.sin(a0));
      context.arc_6p3vsx$(0.0, 0.0, r1, a0, a1, !cw);
      if (r0 > epsilon) {
        context.moveTo_lu1900$(r0 * Math_0.cos(a1), r0 * Math_0.sin(a1));
        context.arc_6p3vsx$(0.0, 0.0, r0, a1, a0, cw);
      }
    }
     else {
      var a01 = a0;
      var a11 = a1;
      var a00 = a0;
      var a10 = a1;
      var da0 = da;
      var da1 = da;
      var ap = this.padAngle(datum) / 2.0;
      if (ap <= epsilon)
        tmp$ = 0.0;
      else {
        var tmp$_0;
        if (this.padRadius != null)
          tmp$_0 = ensureNotNull(this.padRadius)(datum);
        else {
          var x_0 = r0 * r0 + r1 * r1;
          tmp$_0 = Math_0.sqrt(x_0);
        }
        var temp = tmp$_0;
        tmp$ = temp !== 0.0 ? 1.0 : 0.0;
      }
      var rp = tmp$;
      var x_1 = r1 - r0;
      var a = Math_0.abs(x_1) / 2;
      var b = this.cornerRadius(datum);
      var rc = Math_0.min(a, b);
      var rc0 = rc;
      var rc1 = rc;
      if (rp > epsilon) {
        var p0 = asin(rp / r0 * ap);
        var p1 = asin(rp / r1 * ap);
        da0 -= p0 * 2;
        if (da0 > epsilon) {
          p0 *= cw ? 1.0 : -1.0;
          a00 += p0;
          a10 -= p0;
        }
         else {
          da0 = 0.0;
          a10 = (a0 + a1) / 2;
          a00 = a10;
        }
        da1 -= p1 * 2;
        if (da1 > epsilon) {
          p1 *= cw ? 1.0 : -1.0;
          a01 += p1;
          a11 -= p1;
        }
         else {
          da1 = 0.0;
          a11 = (a0 + a1) / 2;
          a01 = a11;
        }
      }
      var tmp$_1 = r1;
      var x_2 = a01;
      var x01 = tmp$_1 * Math_0.cos(x_2);
      var tmp$_2 = r1;
      var x_3 = a01;
      var y01 = tmp$_2 * Math_0.sin(x_3);
      var tmp$_3 = r0;
      var x_4 = a10;
      var x10 = tmp$_3 * Math_0.cos(x_4);
      var tmp$_4 = r0;
      var x_5 = a10;
      var y10 = tmp$_4 * Math_0.sin(x_5);
      var tmp$_5 = r1;
      var x_6 = a11;
      var x11 = tmp$_5 * Math_0.cos(x_6);
      var tmp$_6 = r1;
      var x_7 = a11;
      var y11 = tmp$_6 * Math_0.sin(x_7);
      var tmp$_7 = r0;
      var x_8 = a00;
      var x00 = tmp$_7 * Math_0.cos(x_8);
      var tmp$_8 = r0;
      var x_9 = a00;
      var y00 = tmp$_8 * Math_0.sin(x_9);
      if (rc > epsilon) {
        if (da < pi) {
          var oc = da0 > epsilon ? this.intersect_0(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10];
          var ax = x01 - oc[0];
          var ay = y01 - oc[1];
          var bx = x11 - oc[0];
          var by = y11 - oc[1];
          var tmp$_9 = ax * bx + ay * by;
          var x_10 = ax * ax + ay * ay;
          var tmp$_10 = Math_0.sqrt(x_10);
          var x_11 = bx * bx + by * by;
          var x_12 = acos(tmp$_9 / (tmp$_10 * Math_0.sqrt(x_11))) / 2;
          var kc = 1 / Math_0.sin(x_12);
          var x_13 = oc[0] * oc[0] + oc[1] * oc[1];
          var lc = Math_0.sqrt(x_13);
          var b_0 = (r0 - lc) / (kc - 1);
          rc0 = Math_0.min(rc, b_0);
          var b_1 = (r1 - lc) / (kc + 1);
          rc1 = Math_0.min(rc, b_1);
        }
      }
      if (!(da1 > epsilon))
        context.moveTo_lu1900$(x01, y01);
      else if (rc1 > epsilon) {
        var t0 = this.cornerTangents_0(x00, y00, x01, y01, r1, rc1, cw);
        var t1 = this.cornerTangents_0(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo_lu1900$(t0.cx + t0.x01, t0.cy + t0.y01);
        if (rc1 < rc) {
          var tmp$_11 = t0.cx;
          var tmp$_12 = t0.cy;
          var tmp$_13 = rc1;
          var y = t0.y01;
          var x_14 = t0.x01;
          var tmp$_14 = Math_0.atan2(y, x_14);
          var y_0 = t1.y01;
          var x_15 = t1.x01;
          context.arc_6p3vsx$(tmp$_11, tmp$_12, tmp$_13, tmp$_14, Math_0.atan2(y_0, x_15), !cw);
        }
         else {
          var tmp$_15 = t0.cx;
          var tmp$_16 = t0.cy;
          var tmp$_17 = rc1;
          var y_1 = t0.y01;
          var x_16 = t0.x01;
          var tmp$_18 = Math_0.atan2(y_1, x_16);
          var y_2 = t0.y11;
          var x_17 = t0.x11;
          context.arc_6p3vsx$(tmp$_15, tmp$_16, tmp$_17, tmp$_18, Math_0.atan2(y_2, x_17), !cw);
          var tmp$_19 = r1;
          var y_3 = t0.cy + t0.y11;
          var x_18 = t0.cx + t0.x11;
          var tmp$_20 = Math_0.atan2(y_3, x_18);
          var y_4 = t1.cy + t1.y11;
          var x_19 = t1.cx + t1.x11;
          context.arc_6p3vsx$(0.0, 0.0, tmp$_19, tmp$_20, Math_0.atan2(y_4, x_19), !cw);
          var tmp$_21 = t1.cx;
          var tmp$_22 = t1.cy;
          var tmp$_23 = rc1;
          var y_5 = t1.y11;
          var x_20 = t1.x11;
          var tmp$_24 = Math_0.atan2(y_5, x_20);
          var y_6 = t1.y01;
          var x_21 = t1.x01;
          context.arc_6p3vsx$(tmp$_21, tmp$_22, tmp$_23, tmp$_24, Math_0.atan2(y_6, x_21), !cw);
        }
      }
       else {
        context.moveTo_lu1900$(x01, y01);
        context.arc_6p3vsx$(0.0, 0.0, r1, a01, a11, !cw);
      }
      if (!(r0 > epsilon) || !(da0 > epsilon))
        context.lineTo_lu1900$(x10, y10);
      else if (rc0 > epsilon) {
        var t0_0 = this.cornerTangents_0(x10, y10, x11, y11, r0, -rc0, cw);
        var t1_0 = this.cornerTangents_0(x01, y01, x00, y00, r0, -rc0, cw);
        context.lineTo_lu1900$(t0_0.cx + t0_0.x01, t0_0.cy + t0_0.y01);
        if (rc0 < rc) {
          var tmp$_25 = t0_0.cx;
          var tmp$_26 = t0_0.cy;
          var tmp$_27 = rc0;
          var y_7 = t0_0.y01;
          var x_22 = t0_0.x01;
          var tmp$_28 = Math_0.atan2(y_7, x_22);
          var y_8 = t1_0.y01;
          var x_23 = t1_0.x01;
          context.arc_6p3vsx$(tmp$_25, tmp$_26, tmp$_27, tmp$_28, Math_0.atan2(y_8, x_23), !cw);
        }
         else {
          var tmp$_29 = t0_0.cx;
          var tmp$_30 = t0_0.cy;
          var tmp$_31 = rc0;
          var y_9 = t0_0.y01;
          var x_24 = t0_0.x01;
          var tmp$_32 = Math_0.atan2(y_9, x_24);
          var y_10 = t0_0.y11;
          var x_25 = t0_0.x11;
          context.arc_6p3vsx$(tmp$_29, tmp$_30, tmp$_31, tmp$_32, Math_0.atan2(y_10, x_25), !cw);
          var tmp$_33 = r0;
          var y_11 = t0_0.cy + t0_0.y11;
          var x_26 = t0_0.cx + t0_0.x11;
          var tmp$_34 = Math_0.atan2(y_11, x_26);
          var y_12 = t1_0.cy + t1_0.y11;
          var x_27 = t1_0.cx + t1_0.x11;
          context.arc_6p3vsx$(0.0, 0.0, tmp$_33, tmp$_34, Math_0.atan2(y_12, x_27), cw);
          var tmp$_35 = t1_0.cx;
          var tmp$_36 = t1_0.cy;
          var tmp$_37 = rc0;
          var y_13 = t1_0.y11;
          var x_28 = t1_0.x11;
          var tmp$_38 = Math_0.atan2(y_13, x_28);
          var y_14 = t1_0.y01;
          var x_29 = t1_0.x01;
          context.arc_6p3vsx$(tmp$_35, tmp$_36, tmp$_37, tmp$_38, Math_0.atan2(y_14, x_29), !cw);
        }
      }
       else
        context.arc_6p3vsx$(0.0, 0.0, r0, a10, a00, cw);
    }
    context.closePath();
    return context;
  };
  ArcGenerator.prototype.cornerTangents_0 = function (x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var tmp$ = cw ? rc : -rc;
    var x = x01 * x01 + y01 * y01;
    var lo = tmp$ / Math_0.sqrt(x);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = r1 - rc;
    var D = x11 * y10 - x10 * y11;
    var tmp$_0 = dy < 0 ? -1.0 : 1.0;
    var b = r * r * d2 - D * D;
    var x_0 = Math_0.max(0.0, b);
    var d = tmp$_0 * Math_0.sqrt(x_0);
    var cx0 = (D * dy - dx * d) / d2;
    var cy0 = (-D * dx - dy * d) / d2;
    var cx1 = (D * dy + dx * d) / d2;
    var cy1 = (-D * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
      cx0 = cx1;
      cy0 = cy1;
    }
    return new CornerTangentValues(cx0, cy0, -ox, -oy, cx0 * (r1 / r - 1), cy0 * (r1 / r - 1));
  };
  ArcGenerator.prototype.intersect_0 = function (x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0;
    var y10 = y1 - y0;
    var x32 = x3 - x2;
    var y32 = y3 - y2;
    var t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
    return [x0 + t * x10, y0 + t * y10];
  };
  ArcGenerator.$metadata$ = {kind: Kind_CLASS, simpleName: 'ArcGenerator', interfaces: []};
  var Array_0 = Array;
  var curves_instance = null;
  var areas_instance = null;
  function const$lambda(closure$constantValue) {
    return function (it) {
      return closure$constantValue;
    };
  }
  function const_0(constantValue) {
    return const$lambda(constantValue);
  }
  var epsilon;
  var pi;
  var halfPi;
  var tau;
  function acos(x) {
    return x > 1.0 ? 0.0 : x < -1 ? pi : Math_0.acos(x);
  }
  function asin(x) {
    return x >= 1.0 ? halfPi : x <= -1.0 ? -halfPi : Math_0.asin(x);
  }
  var symbols;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  function ReflectContext(context) {
    this.context = context;
  }
  function linkHorizontal(init) {
    var $receiver = new LinkGenerator();
    $receiver.curve = getCallableRef('curveHorizontal', function ($receiver, context, x0, y0, x1, y1) {
      return $receiver.curveHorizontal_db01oh$(context, x0, y0, x1, y1), Unit;
    }.bind(null, $receiver));
    init($receiver);
    return $receiver;
  }
  function LinkGenerator() {
    this.x0 = const_0(0.0);
    this.x1 = const_0(0.0);
    this.y0 = const_0(0.0);
    this.y1 = const_0(0.0);
    this.curve = getCallableRef('curveHorizontal', function ($receiver, context, x0, y0, x1, y1) {
      return $receiver.curveHorizontal_db01oh$(context, x0, y0, x1, y1), Unit;
    }.bind(null, this));
  }
  LinkGenerator.prototype.link_htbjw1$ = function (data, context) {
    this.curve(context, this.x0(data), this.y0(data), this.x1(data), this.y1(data));
  };
  LinkGenerator.prototype.curveHorizontal_db01oh$ = function (context, x0, y0, x1, y1) {
    context.moveTo_lu1900$(x0, y0);
    var newX0 = (x0 + x1) / 2;
    context.bezierCurveTo_15yvbs$(newX0, y0, newX0, y1, x1, y1);
  };
  LinkGenerator.prototype.curveVertical_db01oh$ = function (context, x0, y0, x1, y1) {
    context.moveTo_lu1900$(x0, y0);
    var newY0 = (y0 + y1) / 2;
    context.bezierCurveTo_15yvbs$(x0, newY0, x1, newY0, x1, y1);
  };
  LinkGenerator.$metadata$ = {kind: Kind_CLASS, simpleName: 'LinkGenerator', interfaces: []};
  var copyToArray = Kotlin.kotlin.collections.copyToArray;
  var StackOffset$NONE_instance;
  var StackOffset$EXPAND_instance;
  var StackOffset$DIVERGING_instance;
  var StackOffset$SILHOUETTE_instance;
  var StackOffset$WIGGLE_instance;
  var wrapFunction = Kotlin.wrapFunction;
  var Comparator = Kotlin.kotlin.Comparator;
  var StackOrder$NONE_instance;
  var StackOrder$ASCENDING_instance;
  var StackOrder$DESCENDING_instance;
  var StackOrder$REVERSE_instance;
  var StackOrder$INSIDEOUT_instance;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var package$io = _.io || (_.io = {});
  var package$data2viz = package$io.data2viz || (package$io.data2viz = {});
  var package$shape = package$data2viz.shape || (package$data2viz.shape = {});
  package$shape.arc_7vwo0o$ = arc;
  package$shape.ArcGenerator = ArcGenerator;
  package$shape.const_lk9rat$ = const_0;
  package$shape.acos_14dthe$ = acos;
  package$shape.asin_14dthe$ = asin;
  var package$link = package$shape.link || (package$shape.link = {});
  package$link.linkHorizontal_j8qibw$ = linkHorizontal;
  package$link.LinkGenerator = LinkGenerator;
  ReflectContext.prototype.arc_6p3vsx$ = PathAdapter.prototype.arc_6p3vsx$;
  epsilon = 1.0E-12;
  pi = math.PI;
  halfPi = pi / 2;
  tau = 2 * pi;
  symbols = ['Circle', 'Cross', 'Diamond', 'Square', 'Star', 'Triangle', 'Wye'];
  return _;
}));

//# sourceMappingURL=d2v-shape-js.js.map



//////////////////
// WEBPACK FOOTER
// ./build/kotlin-js-min/main/d2v-shape-js.js
// module id = 8
// module chunks = 0